// External packages
import { Navigate, Outlet } from 'react-router-dom';

// Hooks
import { useUserRole } from 'components/ProtectedRoute';

export const AdminOnlyRoute = () => {
	const { isAdmin } = useUserRole();

	if (!isAdmin) {
		return <Navigate to="/ulaznice" replace />;
	}

	return <Outlet />;
};
